const mobileMenuTriggerInit = () => {
    const $trigger = $('.c-mobile-menu-trigger'),
        $mobileMenu = $('.mobile-nav'),
        activeClass = 'is-active',
        bodyActiveClass = 'mobile-menu-is-active';

    if ( $trigger.length ) {
        $trigger.on('click', function() {
            $(this).toggleClass(activeClass);
            $mobileMenu.toggleClass(activeClass);
            $('body').toggleClass(bodyActiveClass);
        });
    }
};

// doc ready
$(() => {
    mobileMenuTriggerInit();
});



/** WEBPACK FOOTER **
 ** ./src/components/mobile-header/mobile-nav-trigger/c-mobile-nav-trigger.js
 **/